// extracted by mini-css-extract-plugin
module.exports = {"current":"pagination_current__ZWZdT","disabled":"pagination_disabled__iqXIl","ellipsis":"pagination_ellipsis__xIwkI","paginationButton":"pagination_paginationButton__jo0KE"};